import ExpansionPreviewContextMenu from "./ExpansionPreviewContextMenu";
import ContextMenu from "./ContextMenu";
import { NodeDisplayContext } from './Contexts';
import A from './ActionCreators';
import O from './O';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { layersByChannelIdToLayers } from "./utils";
export default function ExpansionPreviewContainer({
  imageIdsByChannel,
  onEvent,
  focusedRegionId,
  setFocusedRegionId,

  hoveredRegionId,
  setHoveredRegionId,

  containerWidth,
  figurePanelId,
  cellLocation,
  value,
  templateOverrides,
  regionList,
  regionAssignments,
  setRegionAssignments,

  template,

  children

}){

  const dispatch = useDispatch();

  const [ pos, setPos ] = useState();
  const [ targetNode, setTargetNode ] = useState();





  let cm = pos && <ExpansionPreviewContextMenu {...{
    imageIdsByChannel,
      pos,
      setRegionAssignments,
      regionAssignments,
      focusedRegionId,
      regionList,
      template,
      node:targetNode,
      onEvent,
  }}/>


    let expansionPreviewContainer  = (
      <>
        <div style={{
          minHeight:0,
          position:'relative',
          overflow:'hidden',




        }} class="rel flex-expand full-width sg-row h-center">
          <NodeDisplayContext.Provider value={{
            nodeDisplay:function({node}){
              if( node.type === "text" ){ return false; }
              if( node.type !== "region" ){ return null; }
              if( node.type === "scalebar" ){ return null; }
            },
            nodeDecoration:function({node={},regionId,nodeId,content,caller}){





              if( node.type === "region" ){


                let regionId = node?.value?.regionId;

                if( regionId ){

                  let regionClass = ( `absolute-cover ${regionId===focusedRegionId?"hover-border-dark":""} ${hoveredRegionId === regionId ? "hover-border" : ""}`)

                  let layers = layersByChannelIdToLayers(node.value.layersByChannelId);
                  let {imageId} = layers.find(x => x.imageId) || {}


                  return (
                    <>

                      <div 
                        onMouseEnter={() => { regionId && setHoveredRegionId(regionId); }}
                        onMouseLeave={() => { setHoveredRegionId(); }}
                        onMouseDown={e => {
                          e.stopPropagation();
                        }}
                        onClick={(e) => {

                          let cc = caller;
                          let nodeEl = e.target;

                          let bounds = nodeEl.getBoundingClientRect();
                          let nodePos = [
                          bounds.left + 0.5 * bounds.width, bounds.top
                        ]

                          setTargetNode({...node,nodeId});

                          setPos(nodePos);


                          if( focusedRegionId === regionId ){

                            if( false ){
                              let newChannel = prompt(`Enter a channel for ${JSON.stringify(node)}:`)

                              let key = `nodeOverrides.${nodeId}.value~channelGroup`
                              dispatch(A.setCellsValueProperties({
                                figurePanelId,
                                byCellLocation:[{ 
                                  cellLocation,
                                  properties:{
                                    [key]:newChannel
                                  }
                                }],
                              }))
                            }
                          }
                          e.preventDefault(); e.stopPropagation();
                          setFocusedRegionId(regionId); 

                          //let layers = node.value.layers;
                          //let {imageId} = layers.find(x => x.imageId) || {}

                          if(regionId === "main"){
                            let itemToView = content;
                            onEvent({
                              type:"view",
                              itemToView,
                              channelGroup:node.value.channelGroup,
                              imageId,
                              layers,
                            });
                          }
                        }} 
                        style={{ 
                          pointerEvents:'auto',
                          outline:'2px solid white',
                        }} 
                        class={regionClass}>

                      </div>


                    </>
                  )
                }else{
                  return (
                    <div class="absolute-cover selectable-on-hover" style={{ zIndex:100 }} />
                  )
                }
              }else{
                return (
                  <div style={{ zIndex:100, 
                  }} class="outline-on-hover"/>
                )
              }
            }
          }}>
            {children}
          </NodeDisplayContext.Provider>

        </div>

        {pos && cm}
      </>
    )

  return expansionPreviewContainer;


}
